export  const MedicalFsp = 
[
    {
        id: "1",
        name: "Bestmed",
        logo: ""
    },
    {
        id: "2",
        name: "Bonitas",
        logo: ""
    },
    {
        id: "3",
        name: "Compcare",
        logo: ""
    },
    {
        id: "4",
        name: "Discovery",
        logo: ""
    },
    {
        id: "5",
        name: "Fedhealth",
        logo: ""
    },
    {
        id: "6",
        name: "Health Squared",
        logo: ""
    },
    {
        id: "7",
        name: "Hosmed",
        logo: ""
    },
    {
        id: "8",
        name: "Key Health",
        logo: ""
    },
    {
        id: "9",
        name: "Medihelp",
        logo: ""
    },
    {
        id: "10",
        name: "Medshield",
        logo: ""
    },
    {
        id: "11",
        name: "Momentum",
        logo: ""
    },
    {
        id: "12",
        name: "Siswe",
        logo: ""
    }

]
    
    
export const MedicalGapFsp = 
[
    {
        id: "1",
        name: "Agility (Health Squared)",
        logo: ""
    },
    {
        id: "2",
        name: "Medcap (bonitas)",
        logo: ""
    },
    {
        id: "3",
        name: "Curemed",
        logo: ""
    },
    {
        id: "4",
        name: "Discovery",
        logo: ""
    },
    {
        id: "5",
        name: "Liberty (Zest)",
        logo: ""
    },
    {
        id: "6",
        name: "Momentum",
        logo: ""
    },
    {
        id: "7",
        name: "Sirago",
        logo: ""
    },
    {
        id: "8",
        name: "Stratum",
        logo: ""
    },
    {
        id: "9",
        name: "TRA (Total risk administrators)",
        logo: ""
    },
    {
        id: "10",
        name: "Turnberry",
        logo: ""
    }
]

export const MedicalLoyaltyFsp = 
[
    {
        id: "1",
        name: "Agility (Health Squared)",
        logo: ""
    },
    {
        id: "2",
        name: "Healthprint (Medihelp)",
        logo: ""
    },
    {
        id: "3",
        name: "Medshield",
        logo: ""
    },
    {
        id: "4",
        name: "Multiply (Momentum)",
        logo: ""
    },
    {
        id: "5",
        name: "Reality (Bonitas)",
        logo: ""
    },
    {
        id: "6",
        name: "Reality (Fedhealth)",
        logo: ""
    },
    {
        id: "7",
        name: "Vitality (Discovery)",
        logo: ""
    },
]










// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/MedicalFsp.jsx